import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { TimeEntryMetadataKey } from '~/types';
import { getBillingMetadata } from '../util';

export const CREATE_TIME_ENTRY_REVISION_GROUP_BULK_MODIFICATION_BATCH = gql`
  mutation createTimeEntryRevisionGroupBulkModificationBatch(
    $input: TimeEntryRevisionGroupBulkModificationBatchInput!
  ) {
    createTimeEntryRevisionGroupBulkModificationBatch(input: $input)
  }
`;

export const useMoveTimeBatch = ({ setBatchState }) => {
  const [createBatch, { loading }] = useMutation(
    CREATE_TIME_ENTRY_REVISION_GROUP_BULK_MODIFICATION_BATCH
  );

  return {
    createMoveTimeBatch: async ({
      sourceProjectId,
      sourceTaskId,
      destinationProjectId,
      destinationTaskId,
      billingStatus,
      additionalFilters = {}
    }) => {
      const billingMetadata = getBillingMetadata(billingStatus?.id);

      const { data } = await createBatch({
        variables: {
          input: {
            filter: {
              projectId: sourceProjectId,
              taskId: sourceTaskId === undefined ? null : sourceTaskId,
              ...additionalFilters
            },
            modifications: {
              customMetadataToAddOrUpdate: [
                {
                  key: destinationTaskId
                    ? TimeEntryMetadataKey.Task
                    : TimeEntryMetadataKey.Project,
                  value: {
                    uri: destinationTaskId || destinationProjectId
                  }
                },
                ...(billingMetadata.customMetadataToAddOrUpdate || [])
              ].filter(Boolean),
              customMetadataKeysToRemove: [
                TimeEntryMetadataKey.Project,
                TimeEntryMetadataKey.Task,
                ...(billingMetadata.customMetadataKeysToRemove || [])
              ].filter(Boolean)
            }
          }
        },
        awaitRefetchQueries: true
      });

      if (data?.createTimeEntryRevisionGroupBulkModificationBatch) {
        setBatchState({
          batchId: data.createTimeEntryRevisionGroupBulkModificationBatch,
          batchInProgress: true
        });
      }
    },
    loading
  };
};

export default useMoveTimeBatch;
